/**
 * Vasim Hayat @ 2/10/2018
 */

export class FnDateFormatConstant {
    public static readonly NG_DATE_FORMAT_MAP = {
        'MM/dd/YYYY': 'MM/dd/yyyy',
        'MM/DD/YYYY': 'MM/dd/yyyy',
        'DD/MM/YYYY': 'dd/MM/yyyy',
        'dd/MM/YYYY': 'dd/MM/YYYY',
        'dd/mm': 'dd/MM',
        'mm/dd': 'MM/dd',
        'dd/MM': 'dd/MM',
        'MM/dd': 'MM/dd',
        'MM/DD': 'MM/dd',
        'DD/MM': 'dd/MM',
        'MM/dd/yyyy': 'MM/dd/yyyy',
        'MM/DD/yyyy': 'MM/dd/yyyy',
        'mm/dd/yyyy': 'MM/dd/yyyy',
        'DD/MM/yyyy': 'dd/MM/yyyy',
        'dd/MM/yyyy': 'dd/MM/yyyy',
        'yyyy/mm/dd': 'yyyy/MM/dd',
        'yyyy/MM/dd': 'yyyy/MM/dd'
    };

    public static readonly NG_TIME_FORMAT_MAP = {
        'HH:mm': 'HH:mm',
        'hh:mm a': 'hh:mm aaaaa',
        'hh:mm:a': 'hh:mm aaaaa',
        'hh:mm ap': 'hh:mm aaa'
    };


    public static readonly TIME_FORMAT_MAP = {
        'HH:mm': 'H:i',
        'hh:mm:a': 'h:iP',
        'hh:mm:ap': 'h:ia',
        'hh:mm a' : 'h:iP'
    };

    public static readonly DATE_FORMAT_MAP = {
        'MM/dd/YYYY': 'm/d/Y',
        'MM/DD/YYYY': 'm/d/Y',
        'DD/MM/YYYY': 'd/m/Y',
        'dd/MM/YYYY': 'd/m/Y',
        'dd/mm': 'd/m',
        'mm/dd': 'm/d',
        'dd/MM': 'd/m',
        'MM/dd': 'm/d',
        'MM/DD': 'm/d',
        'DD/MM': 'd/m',
        'MM/dd/yyyy': 'm/d/Y',
        'MM/DD/yyyy': 'm/d/Y',
        'mm/dd/yyyy': 'm/d/Y',
        'DD/MM/yyyy': 'd/m/Y',
        'dd/MM/yyyy': 'd/m/Y',
        'yyyy/mm/dd': 'Y/m/d',
        'yyyy/MM/dd': 'Y/m/d'
    }


}
